import { useQueryClient } from "@tanstack/react-query";

import type { Job } from "@core/domains/jobs";

import { getJobsQueryKey } from "../lib/jobs-query-key.ts";

interface JobsData {
  readonly items: readonly Job[];
}

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useJobActions() {
  const queryClient = useQueryClient();
  const updateJob = (job: Job): void => {
    queryClient.setQueriesData<JobsData>(
      { queryKey: getJobsQueryKey(job) },
      data => {
        if (!data) {
          return data;
        }

        const exists = data.items.some(existing => existing.id === job.id);

        return {
          ...data,
          items: exists
            ? data.items.map(existing =>
                existing.id === job.id ? job : existing,
              )
            : [job, ...data.items],
        };
      },
    );
  };

  return { updateJob };
}
